import React, { PropTypes } from "react";

const PreviousWebinarsView = ({
  webinars,
  nextPage,
  pagination,
  count,
  sponsor,
  sponsors,
  onFilterChange,
}) => (
  <div>
    {/*<div className="section_webinars_sponsors_filter">*/}
    {/*  <SelectField*/}
    {/*    value={sponsor}*/}
    {/*    options={sponsors}*/}
    {/*    field_name="sponsor"*/}
    {/*    label={'Filter by sponsors'}*/}
    {/*    onChange={onFilterChange}*/}
    {/*  />*/}
    {/*</div>*/}
    <div className="container_previous">
      {webinars}
      {pagination && (
        <a className="more_item" href="javascript:void(0)" onClick={nextPage}>
          LOAD MORE
        </a>
      )}
    </div>
  </div>
);

PreviousWebinarsView.propTypes = {
  webinar: PropTypes.obj,
  onFilterChange: PropTypes.func,
};

export default PreviousWebinarsView;



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupUserWebinars/Recorded/PreviousWebinarsView.js